import type { PreviewNotes } from "~types/types";

export const PREVIEW_NOTES: PreviewNotes = {
    curationName: "Opinion 2-Up Vertical Xs",
    description:
        "Opinion package with a vertical video and 2-column layout. This package requires content with bylines and vertical video as first story, it will render with a light blue background.",
    links: [
        {
            name: "Figma",
            url: "https://www.figma.com/design/gUJ3trI9XeNXlItbVggAFl/Vertical-Video?node-id=5523-9911&p=f&m=dev",
        },
    ],
};
